import { dateFNS, rangePresets, toISOString } from '@gogame/intl-ts';

export const usePeriodForScreenTracker =
  () =>
  ({ startDate }) => [
    toISOString(dateFNS.subDays(new Date(startDate), 3)),
    rangePresets.TODAY.value[1],
  ];
